import { MenuItem, MenuItemProps, useColorModeValue } from "@chakra-ui/react";
import React from "react";

/**
 * A MenuItem styled as a destructive action.
 *
 * This can't be done by extending the theme, as MenuItem does not have
 * a variant prop available in Chakra UI v1.
 */
export function DestructiveMenuItem(props: MenuItemProps) {
  const color = useColorModeValue("red.600", "red.300");
  const hoverBg = useColorModeValue("red.50", "whiteAlpha.100");
  const hoverColor = useColorModeValue("red.700", "red.200");
  const activeBg = useColorModeValue("red.100", "whiteAlpha.200");

  return (
    <MenuItem
      {...props}
      color={color}
      _hover={{
        backgroundColor: hoverBg,
        color: hoverColor,

        // _hover can take priority over _active, so define _active here
        // to ensure the pressed state wins while hovered.
        _active: {
          backgroundColor: activeBg,
          color: hoverColor,
        },
      }}
      _focus={{
        backgroundColor: hoverBg,
      }}
      _focusVisible={{
        backgroundColor: hoverBg,
      }}
      _active={{
        backgroundColor: activeBg,
        color: hoverColor,
      }}
    />
  );
}
